import axios from "axios";
import moment from "moment";
import { takeLatest, call, put, takeEvery, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../utils/queryParams.js";
import { API_DATE_FORMAT } from "../../../../../app_constants.js";

export const SET_LOADING = "saga/SET_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";

export const FETCH_NOTIFICATION_SUCCESS = "saga/FETCH_NOTIFICATION_SUCCESS";
export const ACCEPT_NOTIFICATION = "saga/FETCH_NOTIFICATION";

export const UPLOAD_IMAGE = "saga/UPLOAD_IMAGE";
export const UPLOAD_IMAGE_SUCCESS = "saga/UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAILURE = "saga/UPLOAD_IMAGE_FAILURE";
export const IMAGE_UPLOADING = "saga/IMAGE_UPLOADING";
export const IMAGE_UPLOADING_SUCCESS = "saga/IMAGE_UPLOADING_SUCCESS";
export const IMAGE_UPLOADING_FAILURE = "saga/IMAGE_UPLOADING_FAILURE";
export const UPDATE_THEME_PREFERENCES = "saga/UPDATE_THEME_PREFERENCES";
export const UPDATE_THEME_PREFERENCES_SUCCESS = "saga/UPDATE_THEME_PREFERENCES_SUCCESS";
export const UPDATE_THEME_PREFERENCES_FAILURE = "saga/UPDATE_THEME_PREFERENCES_FAILURE";
export const UPDATE_TOS_PREFERENCES = "saga/UPDATE_TOS_PREFERENCES";
export const UPDATE_TOS_PREFERENCES_SUCCESS = "saga/UPDATE_TOS_PREFERENCES_SUCCESS";
export const UPDATE_TOS_PREFERENCES_FAILURE = "saga/UPDATE_THEME_PREFERENCES_FAILURE";
export const UPDATE_THEME_SUCCESS = "saga/UPDATE_THEME_SUCCESS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  uploadImage: createAction(UPLOAD_IMAGE),
  imageUploading: createAction(IMAGE_UPLOADING),
  updateThemePreferences: createAction(UPDATE_THEME_PREFERENCES),
  userAcceptTOS: createAction(UPDATE_TOS_PREFERENCES),
  acceptNotification: createAction(ACCEPT_NOTIFICATION)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeEvery(UPLOAD_IMAGE, uploadPhoto);
  yield takeEvery(UPDATE_THEME_PREFERENCES, updateThemePreferences);
  yield takeEvery(UPDATE_TOS_PREFERENCES, userAcceptTOS);
  yield takeEvery(ACCEPT_NOTIFICATION, changeNotificationStatus);
}

export const { acceptNotification } = actionCreators;

export function* getCurrentUserData(data) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });

  try {
    yield getNotification();
  } catch (error) {
    console.error(error);
  }
}

function* getNotification() {
  let organization_id = yield select((state) => state.userMenu.currentUser.organization_id);
  let {
    data: { notification = {} }
  } = yield call(axios.get, queryParams.apiVersion + "notifications", {
    params: { organization_id }
  });
  yield put({ type: FETCH_NOTIFICATION_SUCCESS, payload: notification });
}

function* changeNotificationStatus(data) {
  let user_id = yield select((state) => state.userMenu.currentUser.id);

  try {
    let { status } = yield call(axios.post, queryParams.apiVersion + "notifications", {
      notification: {
        notification_id: data.payload,
        user_id
      }
    });
    if (status == 200) {
      yield getNotification();
    }
  } catch (err) {
    console.error(err);
    yield put({ type: FETCH_NOTIFICATION_SUCCESS, payload: {} });
  }
}

export function* uploadPhoto(data) {
  yield put({ type: IMAGE_UPLOADING_SUCCESS, payload: true });
  try {
    const response = yield call(
      axios.put,
      queryParams.apiVersion +
        "users/" +
        data.payload.id +
        "?organization_id=" +
        data.payload.orgId,
      {
        avatar: data.payload.img
      }
    );
    yield put({ type: UPLOAD_IMAGE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: IMAGE_UPLOADING_SUCCESS, payload: false });

    yield put({ type: UPLOAD_IMAGE_FAILURE, error });
  }
}

export function* updateThemePreferences(data) {
  yield put({ type: UPDATE_THEME_SUCCESS, payload: data.payload });
  try {
    const response = yield call(
      axios.put,
      queryParams.apiVersion + "base/set_default_dashboard_modules",
      {
        theme: data.payload
      }
    );

    yield put({ type: UPDATE_THEME_PREFERENCES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: UPDATE_THEME_PREFERENCES_FAILURE, error });
  }
}

export function* userAcceptTOS(userID) {
  let { organization_id, short_url } = yield select((state) => state.userMenu.currentUser);

  try {
    const response = yield call(axios.put, queryParams.apiVersion + "users/" + userID.payload, {
      organization_id,
      short_url,
      accepted_tos_at: moment().format(API_DATE_FORMAT)
    });

    yield put({ type: UPDATE_TOS_PREFERENCES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: UPDATE_TOS_PREFERENCES_FAILURE, error });
  }
}
